/*!
 * @monogrid/vue-boost v1.2.0 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
let t = {};
const n = () => t, o = (e) => {
  t = e;
};
export {
  n as getEnv,
  o as setEnv
};
